import localForage from 'localforage';
import { combineReducers } from 'redux';
import { createMigrate, persistCombineReducers } from 'redux-persist';
import migrations from './migrations';
import { appReducer } from './reducers/appReducer';
import { clustersReducer } from './reducers/clustersReducer';
import { deeplinkReducer } from './reducers/deeplinkReducer';
import { landingClusterReducer } from './reducers/landingClusterReducer';
import { landingReducer } from './reducers/landingReducer';
import { navReducer } from './reducers/navReducer';
import { seasonCampaignReducer } from './reducers/seasonCampaignReducer';
import { sessionReducer } from './reducers/sessionReducer';

const persistConfig = {
  key: 'persist',
  storage: localForage,
  version: 1,
  migrate: createMigrate(migrations, { debug: false }),
};

const persistReducers = {
  session: sessionReducer,
  landing: landingReducer,
  app: appReducer,
  deeplink: deeplinkReducer,
};

const persist = persistCombineReducers(persistConfig, persistReducers);

const reducers = combineReducers({
  persist,
  nav: navReducer,
  clusters: clustersReducer,
  landing: landingClusterReducer,
  seasonCampaign: seasonCampaignReducer,
});

export default reducers;
